/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InquiryDto } from '../../models/inquiry-dto';

export interface ApiAgencyinquiryGet$Params {
  'api-version'?: string;
}

export function apiAgencyinquiryGet(http: HttpClient, rootUrl: string, params?: ApiAgencyinquiryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InquiryDto>>> {
  const rb = new RequestBuilder(rootUrl, apiAgencyinquiryGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InquiryDto>>;
    })
  );
}

apiAgencyinquiryGet.PATH = '/api/agencyinquiry';
